import { render, staticRenderFns } from "./InventoryItemEdit.vue?vue&type=template&id=2765add8&scoped=true&"
import script from "./InventoryItemEdit.vue?vue&type=script&lang=js&"
export * from "./InventoryItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./InventoryItemEdit.vue?vue&type=style&index=0&id=2765add8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2765add8",
  null
  
)

export default component.exports